@if(businessObject) {
<div class="lm-card-view" [class.lm-card-selected]="selected" (click)="onBusinessObjectClicked(businessObject)">
  <ng-container *ngTemplateOutlet="TileMarkup"></ng-container>
</div>
} @else if (template) {
  <div class="lm-card-view" [class.lm-card-selected]="selected"  (click)="onTemplateClicked(template)">
    <ng-container *ngTemplateOutlet="TileMarkup"></ng-container>
  </div>
} @else {
  <div class="lm-card-view" [class.lm-card-selected]="selected" >
    <ng-container *ngTemplateOutlet="TileMarkup"></ng-container>
  </div>
}

<ng-template #TileMarkup >
<!--  @if(icon) {-->
<!--    <div class="lm-card-image">-->
<!--      <svg soho-icon [icon]="icon"/>-->
<!--      &lt;!&ndash; decorative image, alt can be left blank since there's a title span below &ndash;&gt;-->
<!--    </div>-->
<!--  }-->
  @if(businessObject && businessObject.moduleTag === '_start_') {
    <div class="lm-card-image">
      <span class="image-initials large lm-start-scratch-image"><svg soho-icon [icon]="'new-document'" /></span>
    </div>
  }
  <div class="lm-card-content" [class.lm-start-scratch-card]="businessObject?.moduleTag === '_start_'" [class.lm-card-with-icon]="showIcon">
    <div class="lm-card-title" soho-tooltip [content]="title">
      <span><p class="lm-bold">{{ title }}</p></span>
      @if(template && template.favorite) {
          <div><svg soho-icon icon="star-filled" class="icon lm-facade-favorite"/></div>
      }
    </div>
    @if(description) {
      <p class="lm-card-description" soho-tooltip [content]="description">{{ description}}</p>
    } @else {
      @if (businessObject?.moduleTag !== '_start_') {
        <p class="lm-card-no-description">{{ 'Facade_NoDescription' | translate }}</p>
      }
    }
    @if(businessObject?.moduleTag !== '_start_') {
      <div class="lm-card-tags-container">
        @if(businessObject && category) {
          <ng-container *ngTemplateOutlet="CategoryTag"></ng-container>-->
        }
        @if(template) {
          @if(showTransactionIcon()) {-->
            <ng-container *ngTemplateOutlet="TransactionTag"></ng-container>
          } @else if (showColumnarIcon()) {
            <ng-container *ngTemplateOutlet="ColumnarTag"></ng-container>
          } @else if (showAnalyticsIcon()) {
            <ng-container *ngTemplateOutlet="AnalyticsTag"></ng-container>
          } @else if (showAsOfDateIcon()) {
            <ng-container *ngTemplateOutlet="AsOfDateTag"></ng-container>
          } @else if (showArchiveIcon()) {
            <ng-container *ngTemplateOutlet="ArchiveTag"></ng-container>
          } @else if (showAuditIcon()) {
            <ng-container *ngTemplateOutlet="AuditTag"></ng-container>
          }
          @if(showMyReportIcon()) {
            <ng-container *ngTemplateOutlet="MyReportTag"></ng-container>
          }
          @if (showSharingTag()) {
            <ng-container *ngTemplateOutlet="SharingTag"></ng-container>
          }
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #TransactionTag>
    <div class="tag lm-live-image lm-bold"><span><svg soho-icon icon="lightning" class="icon"/>{{ 'Facade_ReportTypeLive' | translate }}</span></div>
</ng-template>
<ng-template #ColumnarTag>
    <div class="tag lm-my-report-image lm-bold"><span><svg soho-icon icon="line-bar-chart" class="icon"/>{{ 'Facade_ReportTypeColumnar' | translate }}</span></div>
</ng-template>
<ng-template #AnalyticsTag>
    <div class="tag lm-pivot-image lm-bold"><span><svg soho-icon icon="line-chart" class="icon"/>{{ 'Facade_ReportTypePivot' | translate }}</span></div>
</ng-template>
<ng-template #CategoryTag>
    <div class="tag lm-facade-tile" [ngClass]="color()"><span>{{ category }}</span></div>
</ng-template>
<ng-template #MyReportTag>
    <div class="tag lm-my-report-image lm-bold"><span><svg soho-icon icon="user" class="icon"/>{{ 'Facade_MyReport' | translate }}</span></div>
</ng-template>
<ng-template #AsOfDateTag>
    <div class="tag lm-as-of-date-image lm-bold"><span><svg soho-icon icon="calendar" class="icon"/>{{ 'CreateReportAsOfDateLabel' | translate }}</span></div>
</ng-template>
<ng-template #ArchiveTag>
    <div class="tag lm-archive-image lm-bold"><span><svg soho-icon icon="archives" class="icon"/>{{ 'Archive' | translate }}</span></div>
</ng-template>
<ng-template #AuditTag>
    <div class="tag lm-audit-image lm-bold"><span><svg soho-icon icon="history" class="icon"/>{{ 'Audit' | translate }}</span></div>
</ng-template>
<ng-template #SharingTag>
    <div class="tag lm-sharing-image lm-bold"><span soho-tooltip [content]="sharingTooltip()"><svg soho-icon icon="share" class="icon"/>{{ 'Facade_ReportShared' | translate }}</span></div>
</ng-template>